import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

import { AspectRatio, Box } from "@vinomofo/components";

import { StorefrontImage } from "../../types";
import { RelativeSizeImage } from "../relative-size-image";

const Container = styled(Box)<{ isExpired: boolean; skeleton: boolean }>`
  display: block;
  position: relative;
  width: 100%;
  ${({ skeleton }) => {
    if (!skeleton) {
      return `
        div {
          border-top-right-radius: 5px;
          border-top-left-radius: 5px;
        }
      `;
    }
  }}
  opacity: ${({ isExpired }) => (isExpired ? 0.75 : 1)};
  ${({ isExpired }) => (isExpired ? "filter: grayscale(100%);" : "")}

  picture {
    img {
      opacity: 1 !important;
    }
  }
`;
export interface OfferCardImageProps {
  image: StorefrontImage;
  useRelativeSize?: boolean;
  skeleton?: boolean;
  isExpired?: boolean;
  secret?: boolean;
  isSmallBottle?: boolean;
}

const OfferCardImage = ({
  image,
  useRelativeSize = false,
  isExpired,
  secret = false,
  isSmallBottle = false,
  skeleton = false,
}: OfferCardImageProps): JSX.Element => {
  
  return (
    <Container isExpired={isExpired} skeleton={skeleton}>
      {useRelativeSize ? (
        <RelativeSizeImage
          image={image}
          ratio={1}
          secret={secret}
          isSmallBottle={isSmallBottle}
        />
      ) : (
        <AspectRatio ratio={1}>
          <GatsbyImage
            image={image}
            style={{
              width: "100%",
              height: "100%",
              textAlign: "center",
            }}
            imgStyle={{
              objectFit: "contain",
              objectPosition: "bottom center",
              top: "auto",
              bottom: "0",
              width: "100%",
              height: "100%",
            }}
            alt=""
          />
        </AspectRatio>
      )}
    </Container>
  );
};

export default OfferCardImage;
